import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, CircleCheck as CheckCircle2 } from "lucide-react";
import PageHero from "../components/ui-custom/PageHero";
import GlassCard from "../components/ui-custom/GlassCard";
import Reveal from "../components/ui-custom/Reveal";
import { powerProductsCategories } from "../data/mock";
import { getIcon } from "../data/iconMap";

const PowerProductDetail = () => {
  const { slug } = useParams();
  const category = powerProductsCategories.find((c) => c.slug === slug);

  if (!category) return <Navigate to="/power-products" replace />;

  const Icon = getIcon(category.icon);

  return (
    <div>
      <PageHero eyebrow="Power Products" title={category.title} subtitle={category.description} />
      <section className="px-6 pb-28">
        <div className="max-w-5xl mx-auto">
          <Link to="/power-products" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-qcyan mb-10 transition-colors">
            <ArrowLeft size={16} /> Back to Power Products
          </Link>
          <div className="grid sm:grid-cols-2 gap-5">
            {category.items.map((item, i) => (
              <Reveal key={item.name} delay={i * 0.06}>
                <GlassCard className="p-6 h-full">
                  <div className="flex items-start gap-3 mb-2">
                    <CheckCircle2 size={18} className="text-qcyan mt-0.5 shrink-0" />
                    <h3 className="font-display font-semibold text-foreground text-base">{item.name}</h3>
                  </div>
                  <p className="text-sm text-muted-foreground leading-relaxed pl-7">{item.detail}</p>
                </GlassCard>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <div className="mt-12 flex items-center gap-4 glass-panel rounded-xl p-6">
              <Icon size={30} className="text-qamber shrink-0" />
              <p className="text-sm text-muted-foreground leading-relaxed">
                For detailed technical specifications and datasheets on {category.title.toLowerCase()}, please
                reach out to our engineering team via the Contact page.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default PowerProductDetail;
